import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import { Provider } from "@shopify/app-bridge-react";
import { Provider as ReduxProvider } from "react-redux";
import store from "./store";

let config = null;

// test
let query = new URLSearchParams(window.location.search);
let shop = query.get("shop");
let scope = query.get("scope");
let installed = query.get("installed");

if (installed) {
    const redirectUrl = encodeURI(`${window.location.origin}/api/settings`);

    // this is the oauth url of shopify
    const install_url = `https://${shop}/admin/oauth/authorize?client_id=${process.env.REACT_APP_API_KEY}&scope=${scope}&redirect_uri=${redirectUrl}`;

    window.top.location.href = install_url;
} else {
    // ---------------

    function setStorage() {

        // add a new data
        let query = new URLSearchParams(window.location.search);

        let shop = query.get("shop");

        let host = query.get("host");

        if (shop && host) {

            window.shop = shop;
            window.host = host;

            config = {
                apiKey: process.env.REACT_APP_API_KEY,
                shopOrigin: shop,
                host
                // forceRedirect: true,
            };
        }
    }

    setStorage();

    let hostname = window.location.hostname;

    ReactDOM.render(
        hostname === "localhost" ? (
            <ReduxProvider store={store}>
                <>
                    <App />
                </>
            </ReduxProvider>
        ) : config !== null ? (
            <Provider config={config}>
                <ReduxProvider store={store}>
                    <>
                        <App />
                    </>
                </ReduxProvider>
            </Provider>
        ) : (
            <div>Install app</div>
        ),
        document.getElementById("root")
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
}
